import { createGlobalStyle  } from "styled-components";
const baseUrl = process.env ==='development' ? '':'/activity';


export const IconStyle = createGlobalStyle`
  @font-face {
    font-family: "iconfont"; /* Project id 2935790 */
    src: url('${baseUrl}/fonts/iconfont.woff2?t=1642590458544') format('woff2'),
        url('${baseUrl}/fonts/iconfont.woff?t=1642590458544') format('woff'),
        url('${baseUrl}/fonts/iconfont.ttf?t=1642590458544') format('truetype');
  }

  .iconfont {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`


// WEBPACK FOOTER //
// ./src/iconfont/index.js